import { useContext, useEffect, useState } from "react";
import Badge from "./Badge";
import NotificationIcon from "../Assets/Icons/outline/notification.svg";
import UserIcon from "../Assets/Icons/outline/user.svg";
import TimerIcon from "../Assets/Icons/outline/timer-1.svg";
import AdminContext from "../Services/Admin";
import Switch from "./Switch";
import { toast } from "react-toastify";
import tinycolor from "tinycolor2";

const Deadline = ({ type }) => {
	const { loading, getAllMaster, addMaster } = useContext(AdminContext);
	const [data, setData] = useState([]);
	const [dataNotification, setDataNotification] = useState([]);
	const [show, setShow] = useState(false);

	const getData = async () => {
		const newData = await getAllMaster(`master/member/my-task`);
		if (newData) {
			setData(newData);
		}
	};

	const changeStatus = async (project_id, id, evt) => {
		let response = await addMaster(`project/task/${project_id}/status/${id}`, {
			status: evt ? "Completed" : "On Progress",
		});
		if (!response?.message) {
			toast.success("Update Status Success");
		}
	};

	const getDataNotification = async () => {
		const newData = await getAllMaster(`master/member/notification`);
		if (newData) {
			setDataNotification(newData);
		}
	};

	const readNotification = async () => {
		await getAllMaster(`master/member/notification/read`);
	};

	useEffect(() => {
		getData();
		getDataNotification();
	}, []);

	return (
		<div className="rounded-3xl shadow-[0_4px_16px_0_rgba(0,0,0,0.3)] py-5 px-5 mb-5">
			<div className="flex justify-between mb-5">
				<button
					type="button"
					className="relative flex"
					onClick={() => {
						setShow((prev) => (prev ? false : true));
						readNotification();
					}}
				>
					<img src={NotificationIcon} className="w-[30px] h-[30px]" alt="" />
					{dataNotification.length > 0 && (
						<span className="absolute right-1 w-[10px] h-[10px] bg-red-600 rounded-full"></span>
					)}
					{show && (
						<div className="absolute z-[100] right-0 top-[30px]">
							<div className="w-[450px] flex flex-col mt-2 mx-auto rounded-3xl shadow-[0_4px_16px_0_rgba(0,0,0,0.3)] bg-white mb-5 p-3">
								{dataNotification.length > 0 ? (
									dataNotification.slice(0, 10).map((item, index) => (
										<div key={index} className="text-start py-1 px-2 border rounded-2xl mb-1  bg-gray-100">
											{item?.message}
										</div>
									))
								) : (
									<div>No Notifications Yet</div>
								)}
							</div>
						</div>
					)}
				</button>
				<div className="flex items-center">
					<div className="me-5 text-end">
						<div className="font-semibold">{localStorage.getItem("name")}</div>
						<div className="font-light text-base">{localStorage.getItem("role")}</div>
					</div>
					<img src={UserIcon} alt="" className="w-[60px] h-[60px] rounded-full border-4 border-black p-2" />
				</div>
			</div>
			<div className="rounded-xl border-4 border-black py-3 px-2">
				<div className="flex items-center justify-between mb-2">
					<div className="text-md font-semibold">Task Hari ini</div>
					<img src={TimerIcon} className="w-[15px] h-[15px]" alt="" />
				</div>
				<div className={`${type === "dashboard" ? "h-[100px]" : "h-[calc(100vh-280px)]"} overflow-y-auto`}>
					{data?.map((item, index) => (
						<>
							{item?.project?.is_open === 1 && (
								<div className="mb-2" key={index}>
									<div className="flex items-center justify-between">
										<Badge
											className="rounded-full font-[400] text-start flex-auto text-black pt-2 px-3 me-[1px]"
											style={{
												backgroundColor: item?.project?.hex_code,
												color: tinycolor(item?.project?.hex_code)?.isDark() ? " white" : " black",
											}}
										>
											<div className="text-[9px] leading-[9px]">
												{item?.project?.name?.substring(0, 52)}
												{item?.project?.name?.length > 52 && "..."}
											</div>
											<div className="text-[10px] leading-[10px]">
												{item?.name?.substring(0, 43)}
												{item?.name?.length > 43 && "..."}
											</div>
										</Badge>
										<Switch
											project_id={item?.t_projects_id}
											id={item?.id}
											checkValue="Completed"
											noCheckValue="Click Done"
											value={item?.status === "On Progress" ? false : true}
											changeStatus={changeStatus}
										/>
									</div>
								</div>
							)}
						</>
					))}
				</div>
			</div>
		</div>
	);
};

export default Deadline;
